export const MAX_SAVED_TOPIC_COUNT = 100;
